
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorSetpoint as ObiCursorSetpointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-setpoint.js';
 
 
 

 
 export const ObiCursorSetpoint = createComponent({
   react: React,
   tagName: 'obi-cursor-setpoint',
   elementClass: ObiCursorSetpointElement,
   events: {
     
   }
  });
 
 